import { Padding } from "@mui/icons-material";
import { colors } from "@mui/material";

const historialActasStyles = (theme) => ({
  container: {
    p: { xs: 2, md: 4 },
    borderRadius: 2,
    bgcolor: '#fff',
    width: '100%', // Valor predeterminado para todos los breakpoints
  },
  title: {
    color: '#444444',
    fontWeight: 500,
    mb: 4,
    textAlign: 'center'
  },
  exportButton: {
    bgcolor: '#71dd37',
    color: '#fff',
    '&:hover': { bgcolor: '#71dd38' },
    textTransform: 'none',
    borderRadius: 2,
    px: { xs: 1, sm: 2 },
    py: { xs: 0.5, sm: 1 },
    fontSize: { xs: '0.75rem', sm: '0.875rem' }
  },
  tableContainer: {
    overflowX: 'auto',
    borderRadius: 1
  },
  table: {
    minWidth: { xs: 350, sm: 650 }
  },
  headerRow: {
    bgcolor: '#e1e2ff !important',
    color: '#566a7f',
  },
  headerCell: {
    fontWeight: 500,
    color: '#424242'
  },
  headerCellHiddenMobile: {
    fontWeight: 500,
    color: '#424242',
    display: { xs: 'none', sm: 'table-cell' }
  },
  headerCellHiddenTablet: {
    fontWeight: 500,
    color: '#424242',
    display: { xs: 'none', md: 'table-cell' }
  },
  headerCellActions: {
    fontWeight: 500,
    color: '#424242',
    textAlign: 'center'
  },
  tableRow: {
    '&:hover': { bgcolor: '#f0f7ff' }
  },
  cellHiddenMobile: {
    display: { xs: 'none', sm: 'table-cell' }
  },
  cellHiddenTablet: {
    display: { xs: 'none', md: 'table-cell' }
  },
  actionsContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  downloadButton: {
    bgcolor: 'transparent',
    '&:hover': { bgcolor: 'transparent', boxShadow: 'none' },
    padding: '0',
    textTransform: 'none',
    borderRadius: 2,
    color: '#5a5dff',
    position: 'relative',
    top: 3,
    fontSize: { xs: '0.75rem', sm: '0.875rem' }
  },
  emptyStateContainer: {
    py: 4,
    textAlign: 'center'
  },
  filtersContainer: {
    display: 'flex',
    gap: 1,
    flexWrap: 'wrap'
  },
  approvedChip: {
    bgcolor: '#71dd38',
    color: 'white',
    padding: '18px 6px',
    fontWeight: 'bold',
  },
  pendingChip: {
    bgcolor: '#ff9800',
    color: 'white',
    padding: '18px 6px',
    fontWeight: 'bold',
  },
  '& h6': {
    color: 'black !important',
  },
});

export default historialActasStyles;